{
  "0_ALREADY_EXISTS": "\"{0}\" existe déjà.",
  "0_OF_1": "{0} sur {1}",
  "ACCOUNT_ID": "ID du compte",
  "ADD": "Ajouter",
  "ADD_REMOVE_FIELDS": "Ajouter/supprimer des champs",
  "AN_ERROR_OCCURED": "Une erreur s’est produite",
  "APPLY": "Appliquer",
  "APPLY_CHANGES": "Appliquer les modifications",
  "ATTACH": "Joindre",
  "ATTACH_AS_LINK": "Joindre en tant que lien",
  "ATTACHING": "Attachement en cours...",
  "AUTOMATICALLY_RENAME": "Renommer automatiquement",
  "BACK": "Retour",
  "BROWSE": "Parcourir",
  "CANCEL": "Annuler",
  "CHARACTER_COUNT": "Nombre de caractères :",
  "CLOSE": "Fermer",
  "CLOUD": "Cloud",
  "COMMENT": "Commentaire",
  "CONFIGURE_REPOSITORY_SETTINGS": "Configurer les paramètres du dépôt",
  "COULD_NOT_SAVE_0": "Impossible d’enregistrer \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Impossible d'enregistrer « {0} ». Type de fichier non pris en charge.",
  "DATA": "Données",
  "DATE": "Date",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Les champs de date doivent être au format {0}.",
  "DATE_PROVIDED_IS_INVALID": "La date fournie est invalide.",
  "DATE_TIME": "Date/Heure",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Les champs date/heure doivent être au format {0}.",
  "DEFAULT_FOLDER": "<Dossier par défaut>",
  "DETAILS": "Détails",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Voulez-vous appliquer vos modifications de champ ?",
  "DOCUMENT_NAME_IS_EMPTY": "Le nom du document est vide",
  "DRAG_DROP_FILE": "Glisser-déposer le fichier",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Une entrée nommée '{0}' existe déjà dans ce dossier. Veuillez choisir un nom différent.",
  "ENTRY_ID": "ID de l'entrée",
  "ENTRY_NAME": "Nom de l'entrée",
  "ENTRY_NOT_FOUND": "Entrée non trouvée.",
  "ERROR_DOWNLOADING_DOCUMENT": "Erreur lors du téléchargement du document.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Une erreur s'est produite lors de la connexion au serveur.",
  "ERROR_SAVING": "Erreur lors de l’enregistrement :",
  "FAILED_TO_OPEN_FOLDER": "Échec de l'ouverture du dossier",
  "FAILED_TO_SAVE_COLON": "Échec de l’enregistrement :",
  "FAILED_TO_SAVE_PERIOD": "Échec de l’enregistrement.",
  "FEEDBACK": "Retour d'information",
  "FIELDS": "Champs",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Ce fichier dépasse la taille maximale autorisée de 25 Mo.",
  "FILE_EXTENSION": "Extension de fichier",
  "FILE_LOCKED": "Le fichier est verrouillé.",
  "FILE_MODIFIED": "Fichier modifié",
  "FILE_NAME": "Nom du fichier",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Les noms de fichiers ne peuvent pas contenir de barre oblique inversée",
  "FOLDER": "Dossier",
  "INTEGER": "Entier",
  "LIST": "Liste",
  "LOADING": "Chargement...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Les champs longs doivent être des entiers compris entre 0 et 3 999 999 999",
  "LONG_INTEGER": "Entier long",
  "NAME": "Nom",
  "NAME_CONFLICT": "Conflit de nom",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Besoin d’aide pour vous connecter ? Contactez votre administrateur Laserfiche pour obtenir de l’aide.",
  "NEW_FOLDER": "Nouveau dossier",
  "NO": "Non",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Aucun champ supplémentaire attribué",
  "NO_FOLDER_SELECTED": "Aucun dossier sélectionné.",
  "NO_MATCHING_ENTRIES_FOUND": "Aucune entrée correspondante trouvée",
  "NO_MATCHING_FIELDS_FOUND": "Aucun champ correspondant n'a été trouvé.",
  "NO_TEMPLATE_ASSIGNED": "Aucun modèle attribué",
  "NOT_AVAILABLE_WITH_TOKENS": "Non disponible avec des jetons",
  "NUMBER": "Nombre",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Le champ numérique doit être un nombre valide",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Un ou plusieurs champs sont invalides.",
  "OPEN": "Ouvrir",
  "OPEN_IN_LASERFICHE": "Ouvrir dans Laserfiche",
  "OPTIONAL": "Optionnel",
  "OR": "ou",
  "PARENT_FIELD": "Champ parent",
  "PARENT_ID": "ID parent",
  "PARENT_NAME": "Nom parent",
  "PLEASE_SELECT_A_FOLDER": "Veuillez sélectionner un dossier",
  "REASON_FOR_DOWNLOADING": "Raison du téléchargement",
  "REFRESH": "Actualiser",
  "REMOVE": "Supprimer",
  "REMOVE_REPOSITORY": "Supprimer le dépôt ?",
  "REPOSITORY": "Dépôt",
  "REPOSITORY_COUNT": "Nombre de référentiels",
  "REPOSITORY_ID": "ID du dépôt",
  "REPOSITORY_NAME": "Nom du dépôt",
  "REQUIRED": "Obligatoire",
  "REQUIRED_FIELD_IS_EMPTY": "Le champ obligatoire est vide",
  "SAVE_CHANGES": "Enregistrer les modifications",
  "SAVE_TO_LASERFICHE": "Enregistrer dans Laserfiche",
  "SAVED_TO_LASERFICHE": "Enregistré dans Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Enregistré dans Laserfiche :",
  "SAVED_WITH_MISSING_METADATA": "Enregistré avec des métadonnées manquantes :",
  "SAVING": "Enregistrement en cours...",
  "SEARCH_FIELDS": "Rechercher dans les champs",
  "SELECT": "Sélectionner",
  "SELECT_REASON": "Sélectionnez une raison",
  "SELF_HOSTED": "Auto-hébergé",
  "SESSION_COUNT": "Nombre de sessions",
  "SETTINGS": "Paramètres",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Les champs courts doivent être des entiers entre 0 et 64999",
  "SIGN_IN": "Se connecter",
  "SIGN_IN_TO_LASERFICHE": "Connectez-vous à Laserfiche",
  "SIGN_OUT": "Se déconnecter",
  "SIGNING_IN": "Connexion en cours...",
  "SIGNING_OUT": "Déconnexion en cours...",
  "SKIP_THIS_FILE": "Ignorer ce fichier",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Une erreur est survenue. Veuillez réessayer plus tard.",
  "SUBMIT": "Soumettre",
  "SUGGESTION": "Suggestion",
  "TEMPLATE": "Modèle",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Le modèle n’a pas pu être chargé.",
  "TEXT": "Texte",
  "THANK_YOU_FOR_SUBMISSION": "Merci pour votre soumission !",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Ce champ a une longueur maximale autorisée de {0} caractères.",
  "THIS_FOLDER_IS_EMPTY": "Ce dossier est vide.",
  "TIME": "Heure",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Les champs heure doivent être au format {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Impossible de charger tous les champs :",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Impossible de récupérer les informations du dépôt :",
  "UNKNOWN_ERROR": "Erreur inconnue.",
  "USER_NAME": "Nom d’utilisateur",
  "YES": "Oui"
}
